<template>

	<div class="w-full">
		
		<div class="h-48 flex content-center bg-white rounded">
			<div>
				<h1 class="text-xl color-black">
					{{ userData.name }}
				</h1>
				<avatar :username="userData.name" :size="75" backgroundColor="#0F62DF" color="#FFF"></avatar>
			</div>
			<div class="text-right">
				<Dropdown class="ml-auto mt-5 lg:mt-0">
					<template #trigger="{ hasFocus, isOpen }">
						<div class="px-2 py-1 text-white rounded" :class="[(hasFocus || isOpen) ? 'bg-blue-500' : 'bg-blue-700']">
							User Actions <i class="fa fa-caret-down ml-1"></i>
						</div>
					</template>
					<template #dropdown>
						<div class="mt-3 bg-white xl:border rounded-lg w-48 py-2 shadow-xl text-left">
							<a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" v-on:click="viewModal('change-user-password')">Modify User Password</a>
							<a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" v-on:click="viewModal('change-user-permissions')">Modify User Permissions</a>
							<a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" v-on:click="viewModal('change-video-privacy')">Modify Video Public</a>
							<a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" v-on:click="viewModal('suspend-user')">Suspend User</a>
							<a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" v-on:click="viewModal('change-user-email')">Modify User Email Address</a>
						</div>
					</template>
				</Dropdown>
			</div>
		</div>

		<change-user-password></change-user-password>
		<change-user-permissions></change-user-permissions>
		<suspend-user></suspend-user>
		<bulk-change-video-privacy></bulk-change-video-privacy>
		<modify-user-email-address></modify-user-email-address>

	</div>

</template>

<script>

	import { EventBus } from '../../../utils/events';
	import moment from 'moment';
	var Avatar = require('vue-avatar')
	import * as Config from '../../../config'
    import { mapState, mapGetters } from 'vuex';
	import ChangeUserPassword from '../modals/ChangeUserPassword.vue';
	import ChangeUserPermissions from '../modals/ChangeUserPermissions.vue';
	import BulkChangeVideoPrivacy from '../modals/BulkChangeVideoPrivacy.vue';
	import SuspendUser from '../modals/SuspendUser.vue';
	import ModifyUserEmailAddress from '../modals/ModifyUserEmailAddress.vue';

	import Dropdown from '@/components/partials/Dropdown'

	export default {
		name: 'UserDetails',
		data () {
			return {
				userData: {
					name: '',
				},
				videos: {},
				userId: null,
				sales: {},
			}
		},
		components: {
			Dropdown,
			'avatar': Avatar.Avatar,
			'change-user-password': ChangeUserPassword,
			'change-user-permissions': ChangeUserPermissions,
			'bulk-change-video-privacy': BulkChangeVideoPrivacy,
			'suspend-user': SuspendUser,
			'modify-user-email-address': ModifyUserEmailAddress,
		},
		mounted() {
			this.userId = this.$route.params.id
			this.getUserData();
			this.getUsersVideos();
			this.getUsersSales();

			this.$nextTick(function () {
                EventBus.$on('admin-user-data-refresh', this.getUserData);
            }.bind(this));
		},
		methods: {
			...mapGetters([
                'getAuthorizationHeader',
            ]),
			getUserData() {
				var _this = this;
				this.$http.get(Config.apiPath + "/api/v2/admin/users/" + this.userId, this.getAuthorizationHeader()).then((response) => {
                    _this.userData = response.data
                });
			},
			getUsersVideos() {
				var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/videos/user/" + this.userId, this.getAuthorizationHeader()).then((response) => {
                    _this.videos = response.data
                });
			},

			viewModal(modal) {
				console.log(modal)
				if(modal == 'change-user-password') {
					EventBus.$emit('change-user-password-open-modal', this.userData);
				} else if(modal == 'change-user-permissions') {
					EventBus.$emit('change-user-permissions-open-modal', this.userData);
				} else if(modal == 'suspend-user') {
					EventBus.$emit('suspend-user-open-modal', this.userData);
				} else if(modal == 'change-video-privacy') {
					EventBus.$emit('change-video-privacy-open-modal', this.userData);
				} else if(modal == 'change-user-email') {
					EventBus.$emit('change-user-email-open-modal', this.userData)
				}
			},
			getUsersSales() {
				var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/sales/user/" + this.userId, this.getAuthorizationHeader()).then((response) => {
                    _this.sales = response.data
                });
			}
		},
		filters: {
			displayRole: function(data) {
				if(data == 'videographer') {
					return 'Videographer'
				} else if (data == 'media_purchaser') {
					return 'Media Purchaser'
				} else if (data == 'media_producer') {
					return 'Media Producer'
				} else if (data == 'administrator') {
					return 'Administrator'
				} else if (data == 'superadministrator') {
					return 'Super Administrator'
				}
			},
			timeAgo: function(date) {
                return moment.utc(date).fromNow();
			},
			displayDateTime: function(data) {
                return moment.utc(data).local().format('MMMM Do YYYY, h:mm a');
			},
			displayDate: function(data) {
                return moment.utc(data).local().format('MMMM Do YYYY');
			},
			displayLocation: function(data) {
				if(data !== undefined) {
					if(data.city !== null && data.state !== null) {
						return data.city + ", " + data.state;
					}

					return "User has not set a location."
				}
			},
			displayPhoneNumber: function(data) {
				if(data !== undefined ) {
					if(data.phone !== null) {
						return data.phone;
					}

					return "N/A"
				}
			},
			displayMethod: function(data) {
                if(data == 'email') {
                    return "Email"
                } else if(data == 'cdn') {
                    return "CDN"
                } else if(data == 'manual') {
                    return "Manual"
                }
            },
            displayStatus: function(data) {
                if(data == 'pending') {
                    return "Pending"
                } else if(data == 'occurring') {
                    return "Occurring"
                } else if(data == 'complete') {
                    return "Complete"
                }
            },
		}
	}
</script>